<template>
  <div class="page-layout">
    <!-- 顶部标签页（可选） -->
    <div v-if="$slots.tabs" class="page-layout__tabs">
      <slot name="tabs" />
    </div>

    <!-- 筛选区域（可选） -->
    <filter-area
      v-if="showFilter"
      :fields="filterFields"
      :default-expanded="filterExpanded"
      :show-settings="filterShowSettings"
      @reset="handleFilterReset"
      @search="handleFilterSearch"
      @settings="handleFilterSettings"
    />

    <!-- 操作栏（可选） -->
    <action-bar
      v-if="showActionBar"
      :show-add="actionBarShowAdd"
      :add-text="actionBarAddText"
      :show-import="actionBarShowImport"
      :show-export="actionBarShowExport"
      :show-settings="actionBarShowSettings"
      @add="handleAdd"
      @import="handleImport"
      @export="handleExport"
      @settings="handleActionBarSettings"
    >
      <template slot="left">
        <slot name="action-left" />
      </template>
      <template slot="right">
        <slot name="action-right" />
      </template>
    </action-bar>

    <!-- 主要内容区域 -->
    <div class="page-layout__content">
      <slot />
    </div>
  </div>
</template>

<script>
import FilterArea from './FilterArea.vue'
import ActionBar from './ActionBar.vue'

export default {
  name: 'PageLayout',
  components: {
    FilterArea,
    ActionBar
  },
  props: {
    // 筛选区域配置
    showFilter: {
      type: Boolean,
      default: false
    },
    filterFields: {
      type: Array,
      default: () => []
    },
    filterExpanded: {
      type: Boolean,
      default: false
    },
    filterShowSettings: {
      type: Boolean,
      default: false
    },
    // 操作栏配置
    showActionBar: {
      type: Boolean,
      default: false
    },
    actionBarShowAdd: {
      type: Boolean,
      default: false
    },
    actionBarAddText: {
      type: String,
      default: '新增'
    },
    actionBarShowImport: {
      type: Boolean,
      default: false
    },
    actionBarShowExport: {
      type: Boolean,
      default: false
    },
    actionBarShowSettings: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 筛选区域事件
    handleFilterReset() {
      this.$emit('filter-reset')
    },
    handleFilterSearch() {
      this.$emit('filter-search')
    },
    handleFilterSettings() {
      this.$emit('filter-settings')
    },
    // 操作栏事件
    handleAdd() {
      this.$emit('add')
    },
    handleImport() {
      this.$emit('import')
    },
    handleExport() {
      this.$emit('export')
    },
    handleActionBarSettings() {
      this.$emit('action-bar-settings')
    }
  }
}
</script>

